// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-511fdd3a{50%{opacity:.5}}.legend-container[data-v-511fdd3a]{display:flex;grid-gap:3.75rem;gap:3.75rem}.legend-container .legend-elements[data-v-511fdd3a]{display:flex;grid-gap:1rem;gap:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
